import { render, staticRenderFns } from "./StoryNavigation.vue?vue&type=template&id=40ca9162&scoped=true"
import script from "./StoryNavigation.vue?vue&type=script&lang=js"
export * from "./StoryNavigation.vue?vue&type=script&lang=js"
import style0 from "./StoryNavigation.vue?vue&type=style&index=0&id=40ca9162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca9162",
  null
  
)

export default component.exports